import { render, staticRenderFns } from "./ContattiEmergenza.vue?vue&type=template&id=43f84aba&scoped=true"
import script from "./ContattiEmergenza.vue?vue&type=script&lang=js"
export * from "./ContattiEmergenza.vue?vue&type=script&lang=js"
import style0 from "./ContattiEmergenza.vue?vue&type=style&index=0&id=43f84aba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f84aba",
  null
  
)

export default component.exports